module.exports = __webpack_public_path__ + "static/media/181CO250.2f601ba4.jpg";